import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod/v4"

import { Invitation } from "#pages/login/invitation.tsx"

const searchSchema = z.object({
  id: z.string(),
  email: z.string().optional(),
  name: z.string().optional(),
  role: z.string().optional(),
  org: z.string().optional(),
  orgId: z.string().optional(),
})

export const Route = createFileRoute("/_auth/invitation")({
  validateSearch: searchSchema,
  component: InvitationRoute,
})

function InvitationRoute() {
  const search = Route.useSearch()
  return <Invitation {...search} />
}
